import { createActionMiddleware } from '@/redux/actions/reservation/helper';

import getRandomId from '@/utils/uuid';
import * as TaskService from '@/api/todoTask';
import { ReducerState, FilterParam, storeName } from '@/redux/reducers/todoTask';

import { TodoTaskAction } from './constant';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

// 获取未处理待办列表
let listFetchToken: string;
const getUnhandledTaskList = () => {
  return actionWrapper(async (dispatch, getState) => {
    const { filterParam } = getState();
    let updateList = [];
    const token = getRandomId();
    listFetchToken = token;
    try {
      const res = await TaskService.getUnhandledTaskList({
        orderBy: filterParam.listOrderType,
      });
      updateList = res.data;
    } catch (e) {
      //
    }
    if (listFetchToken === token) {
      dispatch({
        type: TodoTaskAction.setTodoList,
        payload: updateList || [],
      });
    }
  });
};

// 刷新待办列表
export const refreshTodoList = () => {
  return (dispatch) => {
    dispatch(getUnhandledTaskList());
  };
};

// 修改筛选数据
export const handleFilterParamChange = (params: Partial<FilterParam>, silent?: boolean) => {
  return actionWrapper((dispatch, getState) => {
    const { filterParam } = getState();
    dispatch({
      type: TodoTaskAction.setFilterParam,
      payload: {
        ...filterParam,
        ...params,
      },
    });
    if (!silent) {
      dispatch(refreshTodoList());
    }
  });
};
